import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Attendre que le DOM soit rendu (notamment après navigation)
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // Pas de hash → scroll en haut
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
